import { render, staticRenderFns } from "./NotificationsNavbarButton.vue?vue&type=template&id=c57cb572&scoped=true&"
import script from "./NotificationsNavbarButton.vue?vue&type=script&lang=ts&"
export * from "./NotificationsNavbarButton.vue?vue&type=script&lang=ts&"
import style0 from "./NotificationsNavbarButton.vue?vue&type=style&index=0&id=c57cb572&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.9.8_wzvh6gi4tchptuexh7cjhim74e/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57cb572",
  null
  
)

export default component.exports